import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import "./main.css";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Pagination from "v-pagination-3";
import router from "./router/index";
import FontAwesome from "./components/fontawesome";

require("@/store/subscriber");

// console.log("processsss", process.env.VUE_APP_BASE_URL);

createApp(App)
  .use(router)
  .use(store)
  .component("font-awesome-icon", FontAwesome)
  .component("Datepicker", Datepicker)
  .component("pagination", Pagination)
  .mount("#app");
